import { getNumberWithoutSpaces } from "../../../../../common/utils/format";
import moment from "moment";
import { message, Modal } from "antd";

export const adjustOfferData = offer => {
  const {
    requestId: request = null,
    number = null,
    vehicleId: vehicle = null,
    profiles = null
  } = offer;
  const newData = {
    id: offer && offer.offerId,
    offerId: offer && offer.offerId,
    requestId: request && request.requestId,
    offerName: "",
    carrierComment: offer.comment || "",
    offerStatus: offer.offerStatusId && offer.offerStatusId.offerStatusId,
    offerStatusName: offer.offerStatusId && offer.offerStatusId.offerStatus,
    creationTime: offer.createdAt && moment(offer.createdAt),
    actionDatetime:
      (offer.actionDatetime && moment(offer.actionDatetime)) || null,
    requestNumber:
      request && request.number && getNumberWithoutSpaces(request.number),
    offerNumber: number && getNumberWithoutSpaces(number),
    customer: "", // Заказчик
    phoneCode: "", // Код телефона
    phoneNumber: "", // Номер телефона
    email: "", // Почта
    serviceType:
      request && request.serviceTypeId && request.serviceTypeId.serviceTypeKey, // Вид транспортной услуги
    serviceTypeName:
      request && request.serviceTypeId && request.serviceTypeId.serviceType,
    passengersCount: request.passengersCount || 0, // Количество пассажиров
    gibddMail: (offer.emailgibdd && offer.emailgibdd) || "",
    passangerCode: (offer.passengerCode && offer.passengerCode) || "",
    vehicleId: vehicle && vehicle.vehicleId,
    vehicleType:
      vehicle && vehicle.vehicleTypeId === 1
        ? "Автобус"
        : vehicle.vehicleTypeId === 2
        ? "Микроавтобус"
        : "Минивэн",
    vehicle: vehicle
      ? `${
          vehicle.vehicleModelId && vehicle.vehicleModelId.vehicleBrandId
            ? vehicle.vehicleModelId.vehicleBrandId.brandName
            : ""
        } ${
          vehicle && vehicle.vehicleModelId && vehicle.vehicleModelId.modelName
            ? vehicle.vehicleModelId.modelName
            : ""
        }, ${vehicle && vehicle.registerSign ? vehicle.registerSign : ""} ${
          vehicle && vehicle.registerRegion ? vehicle.registerRegion : ""
        }`
      : ""
  };
  if (newData.offerName) {
    newData.nameCheck = true;
  }

  if (request.arrivalDatetime) {
    newData.arrivalDatetime =
      request.arrivalDatetime && moment(request.arrivalDatetime);
  }

  if (request.kidsCount) newData.kidsCount = request.kidsCount;
  if (request.accompCount) newData.accompCount = request.accompCount;
  if (request.workersCount) newData.workersCount = request.workersCount;
  if (request.medWorkersCount)
    newData.medWorkersCount = request.medWorkersCount;
  if (request.passengersCount)
    newData.passengersCount = request.passengersCount;
  if (request.profileId && request.profileId.companyId) {
    const company = request.profileId.companyId;
    const { subjectKey } = company.subjectId;
    newData.companyNds = request.profileId.companyId.nds;
    switch (subjectKey) {
      case "physical":
        newData.customer = `${request.profileId.companyId.lastname} ${request.profileId.companyId.name} ${request.profileId.companyId.patronymic}`;
        break;
      case "legal":
        newData.customer = request.profileId.companyId.nameLegal;
        break;
      case "individ":
        newData.customer = request.profileId.companyId.nameLegal;
        break;
      default:
    }
  }
  if (request.profileId && request.profileId.companyId) {
    if (
      request.profileId.companyId.subjectId &&
      request.profileId.companyId.subjectId.subjectKey === "physical"
    ) {
      newData.customer = "ФЛ, ";
      newData.customer += request.profileId.companyId.lastname
        ? request.profileId.companyId.lastname
        : ""; // Заказчик
      newData.customer += request.profileId.companyId.name
        ? " " + request.profileId.companyId.name
        : ""; // Заказчик
      newData.customer += request.profileId.companyId.patronymic
        ? " " + request.profileId.companyId.patronymic
        : ""; // Заказчик
      newData.lastname = request.profileId.companyId.lastname;
      newData.name = request.profileId.companyId.name;
      newData.patronymic = request.profileId.companyId.patronymic;
      newData.birthDate = request.profileId.companyId.birthDate;
      newData.passportSeries = request.profileId.companyId.passportSeries;
      newData.passportNumber = request.profileId.companyId.passportNumber;
    } else {
      newData.customer = request.profileId.companyId.nameLegal; // Заказчик
    }
    newData.companyId = request.profileId.companyId; // полные данные по компании
    newData.customerCompany = request.profileId.companyId.companyId; // полные данные по компании
    newData.subject = request.profileId.companyId.subjectId.subjectKey;
    newData.nameLegal = request.profileId.companyId.nameLegal;
    newData.inn = request.profileId.companyId.inn;
  }

  if (request.profileId && request.profileId.userId) {
    if (request.profileId.userId.phone) {
      const phone = request.profileId.userId.phone.match(
        /^(\+7|\+380|\+375)(.*)/
      );
      if (phone) {
        newData.phoneCode = phone[1]; // Код телефона
        newData.phoneNumber = phone[2]; // Номер телефона
      }
    }
    newData.email = request.profileId.userId.email; // Почта
  }

  if (profiles && profiles.length > 0) {
    newData.drivers = profiles
      .filter(profile => profile.roleId === 6 && profile.userId)
      .map(profile => {
        let userName = profile.userId.lastname
          ? `${profile.userId.lastname} `
          : "";
        userName += profile.userId.name ? `${profile.userId.name[0]}.` : "";
        userName += profile.userId.patronymic
          ? `${profile.userId.patronymic[0]}.`
          : "";
        return {
          id: profile.profileId,
          userName
        };
      });
    // todo add some drivers
    if (newData.drivers.length > 0) {
      newData.driverId = newData.drivers[0].id;
      newData.driver = newData.drivers[0].userName;
    }
  }
  if (request.maintenanceLevels) {
    newData.maintenanceLevels = request.maintenanceLevels.map(
      item => item.maintenanceLevelKey
    );
  }

  if (offer.t2) {
    newData.t2 = offer.t2;
  }
  if (offer.t4) {
    newData.t4 = offer.t4;
  }
  if (offer.t6) {
    newData.t6 = offer.t6;
  }
  if (offer.t7) {
    newData.t7 = offer.t7;
  }
  if (offer.t8) {
    newData.t8 = offer.t8;
  }
  if (offer.t9) {
    newData.t9 = offer.t9;
  }
  if (offer.sh1) {
    newData.sh1 = offer.sh1;
  }
  if (offer.sh2) {
    newData.sh2 = offer.sh2;
  }
  if (offer.sh3) {
    newData.sh3 = offer.sh3;
  }
  if (offer.kp1t) {
    newData.kp1t = offer.kp1t;
  }
  if (offer.kp1p) {
    newData.kp1p = offer.kp1p;
  }
  if (offer.kp2t) {
    newData.kp2t = offer.kp2t;
  }
  if (offer.kp2p) {
    newData.kp2p = offer.kp2p;
  }
  if (offer.kp3t) {
    newData.kp3t = offer.kp3t;
  }
  if (offer.kp3p) {
    newData.kp3p = offer.kp3p;
  }
  if (offer.kp4t) {
    newData.kp4t = offer.kp4t;
  }
  if (offer.kp4p) {
    newData.kp4p = offer.kp4p;
  }
  if (offer.kz1t) {
    newData.kz1t = offer.kz1t;
  }
  if (offer.kz1p) {
    newData.kz1p = offer.kz1p;
  }
  if (offer.kz2t) {
    newData.kz2t = offer.kz2t;
  }
  if (offer.kz2p) {
    newData.kz2p = offer.kz2p;
  }
  if (offer.kz3t) {
    newData.kz3t = offer.kz3t;
  }
  if (offer.kz3p) {
    newData.kz3p = offer.kz3p;
  }
  if (offer.kz4t) {
    newData.kz4t = offer.kz4t;
  }
  if (offer.kz4p) {
    newData.kz4p = offer.kz4p;
  }
  if (offer.s1) {
    newData.s1 = offer.s1;
  }
  if (offer.kp1rcDatetime) {
    newData.kp1urc = offer.kp1rcDatetime && moment(offer.kp1rcDatetime);
  }

  if (offer.price) {
    newData.priceNoNds = offer.price;
  }
  //
  // if (offer.totalPrice) {
  //   newData.totalPrice = offer.totalPrice;
  // } else {
  //   const servicesPrice =
  //     (offer.servicesAdditional &&
  //       offer.servicesAdditional.length > 0 &&
  //       offer.servicesAdditional
  //         .map(item => {
  //           return item.pivot.serviceAdditionalPrice;
  //         })
  //         .reduce((acc, cur) => (cur ? (acc += cur) : acc))) ||
  //     0;
  //
  //   newData.totalPrice = offer.price + servicesPrice;
  // }

  if (request && request.routes) {
    newData["startPlace"] =
      request.routes && request.routes.length ? request.routes[0].route : ""; // Место подачи ТС
    newData["endPlace"] =
      request.routes && request.routes.length
        ? request.routes[request.routes.length - 1].route
        : ""; // Конечный пункт
    newData["routes"] = request.routes;
    request.routes.forEach((route, index) => {
      newData["routeDuration" + index] = moment(route.duration, "HH:mm");
      newData["route" + index] = route.route;
      newData["routeId" + index] = route.routeId;
      newData["latitude" + index] = route.latitude;
      newData["longitude" + index] = route.longitude;
    });
  }

  if (offer.servicesAdditional && offer.servicesAdditional.length > 0) {
    newData.additionalServices = offer.servicesAdditional.map(
      item => item.serviceAdditionalKey
    );

    offer.servicesAdditional.forEach((item, index) => {
      newData["serviceAdditionalPrice" + item.serviceAdditionalKey] =
        item.pivot.serviceAdditionalPrice;
    });
  }

  if (offer.payments && offer.payments.length > 0) {
    newData.predPayChecked = false;
    newData.payChecked = false;
    newData.postPayChecked = false;
    newData[`predPay`] = [];
    newData[`pay`] = [];
    newData[`postPay`] = [];
    let pay = [];
    let predPay = [];
    let postPay = [];

    newData.surchargePaymentDate =
      offer.payments[0].paymentTimeAdd &&
      moment(offer.payments[0].paymentTimeAdd);
    newData.refundFreighterDate =
      offer.payments[0].returnTime && moment(offer.payments[0].returnTime);
    newData.priceAddPayment = offer.payments[0].paymentMethodId;

    offer.payments.forEach((item, index) => {
      // Определяем состояние чекбоксов для
      switch (item.paymentTypeId) {
        case 1: {
          if (!newData.predPayChecked) {
            newData.predPayChecked = true;
            if (newData.predPay && newData.predPay.length > 0) {
              predPay.push(item);
            } else {
              predPay[0] = item;
            }
          }
          break;
        }
        case 2: {
          if (!newData.payChecked) {
            newData.payChecked = true;
            if (newData.pay && newData.pay.length > 0) {
              pay.push(item);
            } else {
              pay[0] = item;
            }
            newData[`payPrice`] = item.payment;
            newData[`payType`] = item.paymentTypeId;
            newData[`paymentTime`] =
              (request.arrivalDatetime && moment(request.arrivalDatetime)) ||
              null;
          }
          break;
        }
        case 3: {
          if (!newData.postPayChecked) {
            newData.postPayChecked = true;

            if (newData.postPay && newData.postPay.length > 0) {
              postPay.push(item);
            } else {
              postPay[0] = item;
            }
          }
          break;
        }
        default: {
          return;
        }
      }

      predPay.forEach((item, index) => {
        newData[`predPayPrice${index}`] = item.payment;
        newData[`predPayType${index}`] = item.paymentTypeId;
        newData[`predPaymentTime${index}`] = moment(item.paymentTime);
      });

      predPay.forEach((_, index) => {
        newData.predPay[index] = index;
      });

      pay.forEach((_, index) => {
        newData.pay[index] = index;
      });

      postPay.forEach((item, index) => {
        newData[`postPayPrice${index}`] = item.payment;
        newData[`postPayType${index}`] = item.paymentTypeId;
        newData[`postPaymentTime${index}`] = moment(item.paymentTime);
      });

      postPay.forEach((_, index) => {
        newData.postPay[index] = index;
      });
    });
  }

  if (
    offer.executors &&
    offer.executors.length > 0 &&
    offer.executors[0].companyId &&
    offer.executors[0].companyId.companyId
  ) {
    newData.performer = offer.executors[0].companyId.companyId;
  }

  if (
    offer.responsible &&
    offer.responsible.length > 0 &&
    offer.responsible[0].profileId
  ) {
    newData.dispatcher = offer.responsible[0].profileId;
  }

  if (
    offer.responsible &&
    offer.responsible.length > 0 &&
    offer.responsible[0].userId &&
    offer.responsible[0].userId.lastname &&
    offer.responsible[0].userId.name &&
    offer.responsible[0].userId.patronymic
  ) {
    newData.dispatcherName =
      offer.responsible[0].userId.lastname +
      " " +
      offer.responsible[0].userId.name[0] +
      ". " +
      offer.responsible[0].userId.patronymic[0] +
      ".";
  }

  if (offer.responsibleDocumentsList) {
    newData.responsibleDocumentsList = offer.responsibleDocumentsList;
    newData.responsibleDocumentsKeyList = offer.responsibleDocumentsList.map(
      item => item.documentTypeKey
    );
    offer.responsibleDocumentsList.forEach(item => {
      newData[item.documentTypeKey] = !!item.isClient;
    });
  }
  return newData;
};

export const dataUpdateOfferRequest = async (data, ymaps) => {
  let newData = {};
  newData.offer_id = data.offerId;
  newData.request_id = data.requestId;
  newData.t2 = data.t2;
  newData.t4 = data.t4;
  newData.t6 = data.t6;
  newData.t7 = data.t7;
  newData.t8 = data.t8;
  newData.t9 = data.t9;
  newData.sh1 = data.sh1;
  newData.sh2 = data.sh2;
  newData.sh3 = data.sh3;
  newData.kp1t = data.kp1t;
  newData.kp2t = data.kp2t;
  newData.kp3t = data.kp3t;
  newData.kp4t = data.kp4t;
  newData.kp1p = data.kp1p;
  newData.kp2p = data.kp2p;
  newData.kp3p = data.kp3p;
  newData.kp4p = data.kp4p;
  newData.kz1t = data.kz1t;
  newData.kz2t = data.kz2t;
  newData.kz3t = data.kz3t;
  newData.kz4t = data.kz4t;
  newData.kz1p = data.kz1p;
  newData.kz2p = data.kz2p;
  newData.kz3p = data.kz3p;
  newData.kz4p = data.kz4p;
  newData.kp1rcDatetime = data.kp1urc;

  if (data.driver) {
    newData.driver_name = data.driver;
  }
  // newData.driver = data.driverId;
  if (data.driverId) {
    newData.drivers = [data.driverId];
  }

  newData.price = data.priceNoNds;
  newData.total_price = data.totalPrice;

  newData.company_executor_id = data.performer;
  newData.responsible_id = data.dispatcher;

  newData.arrival_datetime =
    (data.arrivalDatetime &&
      data.arrivalDatetime.format("YYYY-MM-DD HH:mm:ss")) ||
    null;
  newData.action_datetime =
    (data.actionDatetime &&
      data.actionDatetime.format("YYYY-MM-DD HH:mm:ss")) ||
    null;

  newData.monetization_template_name = data.monetizationTemplateName;
  newData.monetization_template_name_check = data.monetizationTemplateNameCheck;
  if (
    data.responsibleDocumentsKeyList &&
    data.responsibleDocumentsKeyList.length > 0
  ) {
    newData.responsible_documents_list = [];
    data.responsibleDocumentsKeyList.forEach(key => {
      if (newData.responsible_documents_list.length > 0) {
        newData.responsible_documents_list.push({
          is_client: data[key],
          document_type_key: key
        });
      } else {
        newData.responsible_documents_list[0] = {
          is_client: data[key],
          document_type_key: key
        };
      }
    });
  }

  if (data.predPay || data.pay || data.postPay) {
    newData.payments = [];
    if (data.predPayChecked && data.predPay && data.predPay.length > 0) {
      data.predPay.forEach(item => {
        if (data[`predPayPrice${item}`] && data[`predPaymentTime${item}`]) {
          newData.payments.push({
            payment_type_id: 1,
            payment: data[`predPayPrice${item}`],
            payment_time:
              data[`predPaymentTime${item}`] &&
              data[`predPaymentTime${item}`].format("YYYY-MM-DD HH:mm:ss")
          });
        } else if (
          data[`predPayPrice${item}`] &&
          !data[`predPaymentTime${item}`]
        ) {
          throw new Error("Укажите дату предоплаты");
          // message.error("Укажите дату предоплаты");
        }
      });
    }
    if (data.payChecked && data.pay && data.pay.length > 0) {
      if (data[`payPrice`]) {
        newData.payments.push({
          payment_type_id: 2,
          payment: data[`payPrice`],
          payment_time:
            (data[`arrivalDatetime`] &&
              data[`arrivalDatetime`].format("YYYY-MM-DD HH:mm:ss")) ||
            null
        });
      }
    }
    if (data.postPayChecked && data.postPay && data.postPay.length > 0) {
      data.postPay.forEach(item => {
        if (data[`postPayPrice${item}`] && data[`postPaymentTime${item}`]) {
          newData.payments.push({
            payment_type_id: 3,
            payment: data[`postPayPrice${item}`],
            payment_time:
              data[`postPaymentTime${item}`] &&
              data[`postPaymentTime${item}`].format("YYYY-MM-DD HH:mm:ss")
          });
        } else if (
          data[`postPayPrice${item}`] &&
          !data[`postPaymentTime${item}`]
        ) {
          throw new Error("Укажите дату постоплаты");
          // message.error("Укажите дату постоплаты");
        }
      });
    }

    newData.payments = newData.payments.map(item => ({
      ...item,
      payment_time_add:
        data.surchargePaymentDate &&
        data.surchargePaymentDate.format("YYYY-MM-DD HH:mm:ss"),
      return_time:
        data.surchargePaymentDate &&
        data.refundFreighterDate.format("YYYY-MM-DD HH:mm:ss"),
      payment_method_id: data.priceAddPayment
    }));
  }

  if (data.additionalServices && data.additionalServices.length > 0) {
    newData.service_additional = [];
    data.additionalServices.forEach(key => {
      newData.service_additional.push({
        service_additional_key: key,
        service_additional_price: data[`serviceAdditionalPrice${key}`]
      });
    });
  }

  newData.vehicle_id = data.vehicleId;
  newData.vehicle_type_id =
    data.vehicleTypeId === "Автобус"
      ? 1
      : data.vehicleTypeId === "Микроавтобус"
      ? 2
      : 3;

  newData.comment = data.carrierComment || " ";

  newData.routes = data.routes.map((item, index) => {
    return {
      ...item,
      duration: data[`routeDuration${index}`].format("HH:mm:ss")
    };
  });

  if (ymaps) {
    const markers = data.routes.map(route => {
      return [route.latitude, route.longitude];
    });

    await new ymaps.route(markers)
      .then(route => {
        route.getPaths().each((item, index) => {
          if (index !== newData.routes.length) {
            newData.routes[index + 1]["route_length"] =
              item.properties.getAll().RouterRouteMetaData.Length.value &&
              Math.round(
                item.properties.getAll().RouterRouteMetaData.Length.value / 100
              );
            newData.routes[index + 1]["route_time"] =
              item.properties.getAll().RouterRouteMetaData.Time.value &&
              Math.round(
                item.properties.getAll().RouterRouteMetaData.Time.value
              );
          }
        });
      })
      .catch(error => {
        if (error.message === "can't construct a route") {
          Modal.error({
            content: "Проложить наземный маршрут невозможно!",
            title: "Внимание!",
            okText: "Закрыть",
            destroyOnClose: true,
            width: 432
          });
        } else {
          message.error("Произошла ошибка");
        }
        throw new Error();
      });
  }

  return newData;
};

export const adjustMonetizationTemplateData = data => {
  let newData = {};
  newData.t2 = data.t2;
  newData.t4 = data.t4;
  newData.t6 = data.t6;
  newData.t7 = data.t7;
  newData.t8 = data.t8;
  newData.t9 = data.t9;
  newData.sh1 = data.sh1;
  newData.sh2 = data.sh2;
  newData.sh3 = data.sh3;
  newData.kp1t = data.kp1t;
  newData.kp2t = data.kp2t;
  newData.kp3t = data.kp3t;
  newData.kp4t = data.kp4t;
  newData.kp1p = data.kp1p;
  newData.kp2p = data.kp2p;
  newData.kp3p = data.kp3p;
  newData.kp4p = data.kp4p;
  newData.kz1t = data.kz1t;
  newData.kz2t = data.kz2t;
  newData.kz3t = data.kz3t;
  newData.kz4t = data.kz4t;
  newData.kz1p = data.kz1p;
  newData.kz2p = data.kz2p;
  newData.kz3p = data.kz3p;
  newData.kz4p = data.kz4p;
  newData.monetization_template_name = data.monetizationTemplaName;

  return newData;
};
